var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 24,
    viewBox: "0 0 192 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.15625 9.80893L0.830016 7.27927L5.54638 4.59473V7.9504L0.15625 11.3061V9.80893Z",
    fill: "#1C60DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38379 9.9116L7.67026 6.65918V9.29209C7.67026 9.29209 7.56661 10.1697 7.20381 10.3246C6.89284 10.4279 2.38379 13.1124 2.38379 13.1124V9.9116Z",
    fill: "#1C60DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23438 11.4608L9.95074 8.72461V11.4091C9.95074 11.4091 9.95074 12.1319 9.48429 12.39C9.17332 12.5449 5.23438 14.8164 5.23438 14.8164V11.4608Z",
    fill: "#1C60DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2041 3.61394L9.79551 1.96191V5.31759L7.2041 6.86636V3.61394Z",
    fill: "#1C60DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27734 5.62703L11.8688 4.12988V7.64043L9.27734 9.13758V5.62703Z",
    fill: "#1C60DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2988 1.08414L13.061 0V2.32316C13.061 2.32316 13.061 3.51055 12.5945 3.71705C12.4909 3.76868 11.2988 4.43982 11.2988 4.43982V1.08414Z",
    fill: "#1C60DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3507 7.89873L13.1128 6.86621L13.061 9.55075C13.061 9.55075 13.1128 10.2735 12.5945 10.5833C12.4909 10.6865 11.2988 11.2544 11.2988 11.2544C11.2988 11.2544 11.3507 7.79547 11.3507 7.89873Z",
    fill: "#1C60DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4239 3.25251L14.8233 2.32324C14.8233 2.32324 14.8233 3.71714 14.8233 4.6464C14.8233 4.95616 14.7714 5.21428 14.6159 5.47241C14.5123 5.73054 14.305 5.98867 14.0977 6.14355L13.3721 6.60818C13.4239 6.6598 13.4239 3.25251 13.4239 3.25251Z",
    fill: "#1C60DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49455 4.59473C5.49455 4.64635 1.19281 6.76301 0.519047 7.48577C0.830016 7.22764 0.259906 7.7439 0.15625 8.56991L0.363563 16.3654C0.363563 16.3654 0.0525936 17.3979 1.65927 18.3272C2.79949 18.9983 9.48532 23.0251 10.2627 23.3865C11.092 23.7479 11.2993 23.18 11.2993 23.18V15.591C11.2993 15.591 11.5584 14.4036 10.1591 13.526C9.89995 13.3195 1.24464 9.39592 0.881845 8.20853C0.519047 6.86626 5.49455 4.90448 5.49455 4.59473Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9361 15.5392L11.3507 15.2295V23.2831C11.3507 23.2831 11.1434 23.6961 10.9361 23.7477C10.8843 23.7477 10.9361 15.5392 10.9361 15.5392Z",
    fill: "#C0C9D7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.621868 8.46692C0.673696 8.57017 0.725524 8.67342 0.829181 8.72505C0.725524 8.6218 0.673696 8.51855 0.621868 8.46692C0.103586 7.12465 3.78339 5.67913 5.33823 4.69824C5.33823 4.69824 1.6066 6.50514 0.881009 7.17628C0.207242 7.74416 0.207242 8.10554 0.207242 8.10554L0.0517578 8.51855C0.0517578 8.31204 0.0517578 8.10554 0.155414 8.05392C0.155414 8.10554 0.621868 8.36367 0.621868 8.46692Z",
    fill: "#1C60DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79542 13.8356C9.48445 13.5775 5.64917 11.8222 2.9541 10.2734C3.10959 10.3767 3.26507 10.4799 3.36873 10.5316L9.69176 23.1283C9.84725 23.1799 9.95091 23.2315 10.0027 23.2831L10.9356 23.7478V15.6425C10.8838 15.6425 11.0393 14.5067 9.79542 13.8356Z",
    fill: "#1C60DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.362727 17.398C0.207242 17.0883 0.103586 16.7785 0.0517578 16.4688C0.0517578 16.8301 0.155414 17.1399 0.362727 17.398Z",
    fill: "url(#paint0_linear_3_10928)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95414 10.2735C2.02123 9.7056 1.24381 9.18935 0.82918 8.72471C0.777352 8.62146 0.673696 8.56984 0.621868 8.46658C0.621868 8.41496 0.155414 8.05358 0.155414 8.00195C0.103586 8.05358 0.0517578 8.26008 0.0517578 8.51821V16.4686C0.103586 17.0365 0.155414 17.0881 0.310899 17.3978C0.57004 17.7592 0.673696 17.9141 1.08832 18.2755C2.07306 18.8434 8.0333 22.2507 9.6918 23.1283L3.36876 10.5316L2.95414 10.2735Z",
    fill: "#1C60DD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.90238 10.2735C1.96947 9.7056 1.19205 9.18935 0.777423 8.72471C0.725595 8.62146 0.621938 8.56984 0.57011 8.46658C0.57011 8.41496 0.103656 8.05358 0.103656 8.00195C0.0518282 8.05358 0 8.36333 0 8.56984L0.0518282 16.5202C0.0518282 17.0365 0.155485 17.1397 0.310969 17.4495C0.518282 17.8108 0.777423 18.0174 1.08839 18.2755C2.07313 18.8434 8.03337 22.2507 9.69187 23.1283L3.317 10.5316L2.90238 10.2735Z",
    fill: "url(#paint1_linear_3_10928)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53635 17.14L8.24064 16.314C7.9815 16.1591 7.77419 16.2624 7.87785 16.5205V18.6888C7.92967 18.792 8.03333 19.0501 7.9815 19.1534C7.77419 19.1534 8.7071 19.9278 9.27721 20.2375C9.43269 20.3408 9.74366 20.3408 9.69183 20.031V17.4497C9.69183 17.3981 9.69183 17.3465 9.64 17.2949C9.64 17.1916 9.58817 17.14 9.53635 17.14Z",
    fill: "#B0B5BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48467 17.2434C9.27736 16.9853 8.60359 16.6239 8.13714 16.2625C8.03348 16.1592 7.82617 16.2625 7.82617 16.3657C7.878 18.0178 7.878 18.7405 7.98166 19.0503C8.03348 19.3084 8.81091 19.8247 9.27736 20.0828C9.43285 20.1861 9.58833 20.1861 9.58833 20.0312C9.58833 19.36 9.58833 17.7596 9.58833 17.3466C9.5365 17.3466 9.5365 17.295 9.48467 17.2434Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5508 9.86437C22.5508 14.7457 26.3282 18.1017 30.9225 18.1017C34.2916 18.1017 37.2523 16.4745 38.4774 13.2203H35.2104C34.2916 14.9491 32.7601 15.7627 30.8204 15.7627C27.5534 15.7627 25.2052 13.4237 25.2052 9.76268C25.2052 6.10166 27.5534 3.86437 30.8204 3.86437C32.7601 3.86437 34.2916 4.67793 35.2104 6.40675H38.4774C37.2523 3.2542 34.2916 1.52539 30.9225 1.52539C26.3282 1.62709 22.5508 4.98302 22.5508 9.86437Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.281 11.5936C53.281 7.52577 50.3202 4.9834 46.6449 4.9834C42.9695 4.9834 40.0088 7.52577 40.0088 11.5936C40.0088 15.6614 42.7653 18.2037 46.4407 18.2037C50.2182 18.2037 53.281 15.5597 53.281 11.5936ZM42.7653 11.5936C42.7653 8.64441 44.603 7.32238 46.5428 7.32238C48.5847 7.32238 50.4223 8.74611 50.4223 11.5936C50.4223 14.5427 48.4826 15.9664 46.4407 15.9664C44.5009 15.8648 42.7653 14.441 42.7653 11.5936Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2209 18H57.8753V5.18644H55.2209V18ZM56.5481 3.45763C57.4669 3.45763 58.2837 2.74576 58.2837 1.72881C58.2837 0.813559 57.569 0 56.5481 0C55.6293 0 54.8125 0.711864 54.8125 1.72881C54.8125 2.74576 55.6293 3.45763 56.5481 3.45763Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8193 18.0003H72.4737V10.4749C72.4737 6.9156 70.2277 4.9834 67.1649 4.9834C65.6335 4.9834 64.2041 5.59357 63.2853 6.61052V5.18679H60.6309V18.0003H63.2853V10.8817C63.2853 8.54272 64.6125 7.32238 66.5523 7.32238C68.4921 7.32238 69.8193 8.54272 69.8193 10.8817V18.0003Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8859 9.25381V3.96567H80.8466C82.8885 3.96567 83.9094 4.98262 83.9094 6.60974C83.9094 8.23686 82.9906 9.25381 80.8466 9.25381H77.8859ZM86.6659 6.60974C86.6659 3.96567 84.7262 1.83008 80.8466 1.83008H75.2314V17.9996H77.8859V11.3894H80.8466C85.1345 11.3894 86.6659 8.94872 86.6659 6.60974Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.584 11.4919C87.584 15.458 90.2384 18.2037 93.6075 18.2037C95.7515 18.2037 97.2829 17.1868 98.0996 16.0681V18.0003H100.754V5.18679H98.2017V7.0173C97.385 6.00035 95.8536 4.9834 93.7096 4.9834C90.2384 4.9834 87.584 7.52577 87.584 11.4919ZM98.2017 11.5936C98.2017 14.3393 96.2619 15.9664 94.3222 15.9664C92.2803 15.9664 90.4426 14.3393 90.4426 11.5936C90.4426 8.8478 92.3824 7.32238 94.3222 7.32238C96.2619 7.22069 98.2017 8.8478 98.2017 11.5936Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.82 14.9492L105.144 5.18652H102.184L107.288 17.7967L104.634 24.0001H107.39L115.354 5.18652H112.597L108.82 14.9492Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.955 18.0003H137.61V10.4749C137.61 6.9156 135.262 4.9834 132.301 4.9834C130.463 4.9834 128.626 6.00035 127.809 7.52577C126.89 5.89865 125.154 4.9834 123.113 4.9834C121.581 4.9834 120.152 5.59357 119.335 6.61052V5.18679H116.681V18.0003H119.335V10.8817C119.335 8.54272 120.662 7.32238 122.602 7.32238C124.542 7.32238 125.869 8.54272 125.869 10.8817V18.0003H128.524V10.8817C128.524 8.54272 129.851 7.32238 131.791 7.32238C133.73 7.32238 135.058 8.54272 135.058 10.8817V18.0003H134.955Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.778 7.22069C147.819 7.22069 149.351 8.44102 149.351 10.4749H142.204C142.511 8.44102 144.042 7.22069 145.778 7.22069ZM151.903 14.1359H149.045C148.534 15.1529 147.615 15.9664 145.982 15.9664C144.042 15.9664 142.511 14.6444 142.306 12.6105H152.209C152.312 12.2037 152.312 11.797 152.312 11.2885C152.312 7.52577 149.657 4.9834 145.982 4.9834C142.204 4.9834 139.55 7.52577 139.55 11.5936C139.55 15.6614 142.306 18.2037 145.982 18.2037C149.045 18.2037 151.086 16.3732 151.903 14.1359Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.338 18.0003H165.992V10.4749C165.992 6.9156 163.746 4.9834 160.683 4.9834C159.152 4.9834 157.723 5.59357 156.804 6.61052V5.18679H154.149V18.0003H156.804V10.8817C156.804 8.54272 158.131 7.32238 160.071 7.32238C162.011 7.32238 163.338 8.54272 163.338 10.8817V18.0003Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.157 14.441C169.157 17.085 170.587 18.0003 172.935 18.0003H175.079V15.763H173.445C172.322 15.763 171.914 15.3562 171.914 14.441V7.32232H175.079V5.18672H171.914V2.03418H169.259V5.18672H167.626V7.32232H169.157V14.441Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M186.411 14.4409C186.309 9.76293 178.958 11.2884 178.958 8.64428C178.958 7.83072 179.673 7.22055 181.102 7.22055C182.532 7.22055 183.45 8.03411 183.552 9.15276H186.207C186.105 6.61038 184.165 5.08496 181.204 5.08496C178.141 5.08496 176.202 6.71208 176.202 8.74598C176.202 13.4239 183.757 12.0002 183.757 14.5426C183.757 15.4578 182.94 16.068 181.408 16.068C179.979 16.068 178.958 15.2545 178.856 14.1358H176.1C176.202 16.4748 178.448 18.3053 181.511 18.3053C184.471 18.2036 186.411 16.5765 186.411 14.4409Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_10928",
    x1: 4.36889,
    y1: 12.1277,
    x2: 0.261389,
    y2: 16.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C60DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_10928",
    x1: 6.38585,
    y1: 13.8613,
    x2: 2.27857,
    y2: 18.6385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C60DD",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinPayment);
export default __webpack_public_path__ + "static/media/coinPayment.32db230b50b6f945ba943f401c92cd49.svg";
export { ForwardRef as ReactComponent };